// extracted by mini-css-extract-plugin
export default {"MenuContainer":"MenuContainer_MenuContainer__vJdTT"};